/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "c8c09768c12c1ceed0dceafc8e5ccfb3d9e4a426";
